import UploadAvatar from './upload_avatar_container';

export default UploadAvatar;